/*
  BSN Gallery: filter chips, fade-up reveal, lightbox.
  Loaded by bsn-gallery and bsn-gallery-nav; the guard makes repeat
  <script> tags harmless. Re-initializes on theme editor section reloads.
*/
(function () {
  if (window.BSNGallery) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Reveal ---------------- */
  var revealObserver = 'IntersectionObserver' in window && !reduceMotion
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function initReveal(root) {
    if (!revealObserver) return;
    root.querySelectorAll('.bsn-gallery__grid:not(.is-revealing)').forEach(function (grid) {
      grid.classList.add('is-revealing');
      grid.querySelectorAll('.bsn-gallery__item').forEach(function (item, i) {
        item.style.setProperty('--reveal-delay', (i % 4) * 70 + 'ms');
        revealObserver.observe(item);
      });
    });
  }

  /* ---------------- Filters ---------------- */
  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-bsn-gallery]'));
  }

  function applyFilter(target, nav) {
    var list = sections();
    var known = list.some(function (s) { return s.id === target; });
    if (!known) target = 'all';
    list.forEach(function (s) {
      s.hidden = target !== 'all' && s.id !== target;
    });
    if (nav) {
      nav.querySelectorAll('.bsn-gallery-nav__chip').forEach(function (chip) {
        chip.setAttribute('aria-pressed', String(chip.dataset.target === target));
      });
    }
    /* Newly shown tiles may already be on screen */
    list.forEach(function (s) {
      if (!s.hidden) s.querySelectorAll('.bsn-gallery__item').forEach(function (item) {
        var r = item.getBoundingClientRect();
        if (r.top < window.innerHeight) item.classList.add('is-visible');
      });
    });
    return target;
  }

  function initNav(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    var group = nav.querySelector('.bsn-gallery-nav__chips');
    sections().forEach(function (s) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'bsn-gallery-nav__chip';
      chip.dataset.target = s.id;
      chip.setAttribute('aria-pressed', 'false');
      chip.setAttribute('aria-controls', s.id);
      chip.textContent = s.dataset.galleryChip || s.id;
      group.appendChild(chip);
    });

    group.addEventListener('click', function (e) {
      var chip = e.target.closest('.bsn-gallery-nav__chip');
      if (!chip) return;
      var target = applyFilter(chip.dataset.target, nav);
      history.replaceState(null, '', target === 'all' ? location.pathname + location.search : '#' + target);
      var first = target === 'all' ? sections()[0] : document.getElementById(target);
      if (first && nav.getBoundingClientRect().top <= parseFloat(getComputedStyle(nav).top) + 1) {
        first.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      chip.scrollIntoView({ block: 'nearest', inline: 'center' });
    });

    var fromHash = decodeURIComponent(location.hash.slice(1));
    if (fromHash) applyFilter(fromHash, nav);
  }

  /* In-page links like <a href="#night-3"> select that night too */
  window.addEventListener('hashchange', function () {
    var target = decodeURIComponent(location.hash.slice(1)) || 'all';
    document.querySelectorAll('[data-bsn-gallery-nav]').forEach(function (nav) {
      applyFilter(target, nav);
    });
  });

  /* ---------------- Lightbox ---------------- */
  var box, img, caption, counter, items = [], index = 0, opener = null;

  function buildBox() {
    box = document.createElement('dialog');
    box.className = 'bsn-lightbox';
    box.setAttribute('aria-label', 'Photo viewer');
    box.innerHTML =
      '<div class="bsn-lightbox__bar"><span class="bsn-lightbox__counter" aria-live="polite"></span>' +
      '<button type="button" class="bsn-lightbox__btn bsn-lightbox__close" aria-label="Close photo viewer">&times;</button></div>' +
      '<div class="bsn-lightbox__stage">' +
      '<button type="button" class="bsn-lightbox__btn bsn-lightbox__prev" aria-label="Previous photo">&#8592;</button>' +
      '<img class="bsn-lightbox__img" alt="">' +
      '<button type="button" class="bsn-lightbox__btn bsn-lightbox__next" aria-label="Next photo">&#8594;</button>' +
      '</div>' +
      '<p class="bsn-lightbox__caption"></p>';
    document.body.appendChild(box);
    img = box.querySelector('.bsn-lightbox__img');
    caption = box.querySelector('.bsn-lightbox__caption');
    counter = box.querySelector('.bsn-lightbox__counter');

    box.querySelector('.bsn-lightbox__close').addEventListener('click', close);
    box.querySelector('.bsn-lightbox__prev').addEventListener('click', function () { show(index - 1); });
    box.querySelector('.bsn-lightbox__next').addEventListener('click', function () { show(index + 1); });
    box.addEventListener('close', function () {
      document.documentElement.classList.remove('bsn-lightbox-open');
      if (opener) opener.focus();
    });
    /* Click on the dark surround closes; clicks on the photo or controls don't */
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('bsn-lightbox__stage')) close();
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
    img.addEventListener('load', function () { img.classList.remove('is-loading'); });

    var startX = null;
    var stage = box.querySelector('.bsn-lightbox__stage');
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1));
    });
  }

  function preload(i) {
    var link = items[(i + items.length) % items.length];
    if (link) (new Image()).src = link.href;
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    var link = items[index];
    var thumb = link.querySelector('img');
    img.classList.add('is-loading');
    img.src = link.href;
    img.alt = thumb ? thumb.alt : '';
    var group = link.dataset.group ? link.dataset.group + ' · ' : '';
    caption.textContent = link.dataset.caption || '';
    counter.textContent = group + (index + 1) + ' / ' + items.length;
    preload(index + 1);
    preload(index - 1);
  }

  function open(link) {
    if (!box) buildBox();
    /* Navigate only among photos currently shown (respects the filter) */
    items = Array.prototype.slice.call(document.querySelectorAll('[data-bsn-gallery]:not([hidden]) [data-bsn-lightbox]'));
    opener = link;
    show(Math.max(0, items.indexOf(link)));
    document.documentElement.classList.add('bsn-lightbox-open');
    box.showModal();
  }

  function close() {
    if (box && box.open) box.close();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-bsn-lightbox]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (typeof HTMLDialogElement !== 'function') return;
    e.preventDefault();
    open(link);
  });

  /* ---------------- Boot ---------------- */
  function init() {
    initReveal(document);
    document.querySelectorAll('[data-bsn-gallery-nav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-bsn-gallery-nav]').forEach(function (nav) {
      delete nav.dataset.ready;
      nav.querySelectorAll('.bsn-gallery-nav__chip:not([data-target="all"])').forEach(function (c) { c.remove(); });
    });
    init();
  });

  window.BSNGallery = { init: init };
})();
